export default __webpack_public_path__ + "static/media/cart2.5a91bb05.jpg";